// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-registration-form .phone-req-explanation{font-size:0.8rem;margin-bottom:1em;font-style:italic;line-height:1.2}\n", ""]);
// Exports
module.exports = exports;
